import React from "react";
import useSEO from "../lib/useSEO";

export default function Terms() {
    useSEO({ title: "Terms of Service", description: "Terms governing your use of the Rotimi Jacobs & Co website and publications.", path: "/terms" });
    return (
        <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="page-terms">
            <div className="font-mono-cap text-xs text-[#c5a059] mb-3">Terms of Service</div>
            <h1 className="font-serif-display text-4xl md:text-5xl text-slate-900 leading-tight">Terms of Service</h1>
            <p className="text-sm text-slate-600 mt-3">Last updated: February 2026</p>
            <div className="rj-rule-gold w-12 my-8" />

            <div className="space-y-6 text-[17px] text-slate-800 leading-relaxed">
                <p>
                    These terms govern your use of the Rotimi Jacobs &amp; Co., Legal Practitioners website
                    ("the site"). By using the site, you agree to be bound by these terms.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">No attorney-client relationship</h2>
                <p>
                    Browsing the site, submitting an inquiry or downloading our publications does not create an
                    attorney-client relationship. A relationship is only established upon execution of a written
                    engagement letter signed by a partner of the firm.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Publications</h2>
                <p>
                    Books, articles and other publications offered for sale on the site are protected by copyright.
                    Hardcover copies are dispatched within Nigeria upon confirmed payment. Digital (PDF) copies are
                    licensed to the purchaser for personal use; redistribution, resale or unauthorised sharing is
                    prohibited.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Payments</h2>
                <p>
                    Payments are processed by Paystack. Orders are confirmed once payment has been verified.
                    Refunds for hardcover purchases are subject to the firm's returns policy; digital downloads are
                    non-refundable once accessed.
                </p>
                <p>
                    Manual bank transfers are also accepted. Use the following details for direct payment:
                </p>
                <div className="border border-slate-900/10 bg-[#fff8e1] p-4 rounded-sm text-sm text-slate-800">
                    <div><strong>Bank:</strong> Access Bank</div>
                    <div><strong>Account name:</strong> Rotimi Jacobs &amp; Co.</div>
                    <div><strong>Account number:</strong> 1725603532</div>
                </div>
                <p>
                    Admin will confirm your order manually once payment is received. Please include your order reference in the transfer narration.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Use of the site</h2>
                <p>
                    You agree not to misuse the site, attempt to gain unauthorised access to internal systems
                    (including webmail), or upload malicious content. The firm reserves the right to suspend
                    accounts that breach these terms.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Limitation of liability</h2>
                <p>
                    Content on the site is provided for general information only. It does not constitute legal
                    advice and should not be relied upon as such. The firm accepts no liability for losses arising
                    from reliance on the site's general content.
                </p>

                <h2 className="font-serif-display text-2xl text-slate-900 pt-4">Governing law</h2>
                <p>
                    These terms are governed by the laws of the Federal Republic of Nigeria. Any dispute arising
                    out of or in connection with them is subject to the exclusive jurisdiction of the courts of
                    Lagos State.
                </p>
            </div>
        </article>
    );
}
